import { createAction } from '@reduxjs/toolkit';

export const addRosterAttendeeAction = createAction('chime/addRosterAttendeeAction');
export const chooseAudioInputDeviceAction = createAction('chime/chooseAudioInputDevice');
export const chooseAudioOutputDeviceAction = createAction('chime/chooseAudioOutputDevice');
export const chooseVideoInputDeviceAction = createAction('chime/chooseVideoInputDevice');
export const errorAction = createAction('chime/errorAction');
export const initAction = createAction('chime/initAction');
export const leaveRoomAction = createAction('chime/leaveRoomAction');
export const removeRosterAttendeeAction = createAction('chime/removeRosterAttendeeAction');
export const resetStateAction = createAction('chime/resetStateAction');
export const setActiveSpeakersAction = createAction('chime/setActiveSpeakersAction');
export const setAudioDeviceListAction = createAction('chime/setAudioDeviceListAction');
export const setAudioDeviceListsAction = createAction('chime/setAudioDeviceListsAction');
export const setCurrentDeviceAction = createAction('chime/setCurrentDeviceAction');
export const setExternalMeetingAction = createAction('chime/setExternalMeetingAction');
export const setHasJoinedAction = createAction('chime/setHasJoinedAction');
export const setHasMeetingBeenCreatedAction = createAction('chime/setHasMeetingBeenCreatedAction');
export const setHostAction = createAction('chime/setHostAction');
export const setInitialParamsAction = createAction('chime/setInitialParamsAction');
export const setJoinInfoAction = createAction('chime/setJoinInfoAction');
export const setMeetingStatusAction = createAction('chime/setMeetingStatusAction');
export const startMessagingAction = createAction('chime/startMessagingAction');
export const startVideoPreviewAction = createAction('chime/startVideoPreviewAction');
export const successAction = createAction('chime/successAction');
export const updateRosterAttributeAction = createAction('chime/updateRosterAttributeAction');
export const chooseUpstreamVideoQualityAction = createAction(
  'chime/chooseUpstreamVideoQualityAction'
);
export const setUpstreamVideoQualityAction = createAction('chime/setUpstreamVideoQualityAction');
